<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Cash Flow - Yearly 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                <button class="btn btn-primary mr-1" @click="cfinvalid()">
                    <i class="fa fa-search"></i> Trx. Invalid CF Acc.
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="4">
                <b-form-group label-cols=3 label="Line Layout">
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" ></b-form-select>
                </b-form-group>
                </b-col>
                <b-col lg="4">
                <b-form-group label-cols=3 label="Periode Date">
                    <b-row>
                        <b-col class="pr-1" cols="6"><b-form-input v-model="filter.tgl1" type="date" placeholder="from date" readonly></b-form-input></b-col>
                        <b-col class="pl-1" cols="6"><b-form-input v-model="filter.tgl2" type="date" placeholder="until date" @change="updateTgl1"></b-form-input></b-col>
                    </b-row>                      
                </b-form-group>
                </b-col>
            </b-row >
            <b-row class="mb-2">
                <b-col lg="5">
                    <b-input-group>
                        <b-input-group-prepend ><span class="ml-2 mr-1 pt-1">View : </span></b-input-group-prepend>
                        <b-form-radio-group class="mt-2" v-model="filter.view" name="radioView">
                            <b-form-radio value="ytd">Year to Date  </b-form-radio>
                            <b-form-radio value="full">Full Coloum (12 Months)</b-form-radio>
                        </b-form-radio-group>
                    </b-input-group>
                </b-col>
                <b-col lg="7">
                    <b-input-group v-if="(filter.view=='full')">
                        <b-input-group-prepend><label> &nbsp;&nbsp;&nbsp;Hide Column   :</label></b-input-group-prepend>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="janShow" class="mt-1 mr-2" size="sm">Jan</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="febShow" class="mt-1 mr-2" size="sm">Feb</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="marShow" class="mt-1 mr-2" size="sm">Mar</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="aprShow" class="mt-1 mr-2" size="sm">Apr</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="meiShow" class="mt-1 mr-2" size="sm">Mei</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="junShow" class="mt-1 mr-2" size="sm">Jun</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="julShow" class="mt-1 mr-2" size="sm">Jul</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="agtShow" class="mt-1 mr-2" size="sm">Agt</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="sepShow" class="mt-1 mr-2" size="sm">Sep</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="oktShow" class="mt-1 mr-2" size="sm">Oct</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="novShow" class="mt-1 mr-2" size="sm">Nov</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="desShow" class="mt-1 mr-2" size="sm">Dec</b-form-checkbox>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-card no-body class="mb-0">
                <div class="report-wraper">
                    <table >
                        <thead>
                            <tr>
                            <th width="400px">Description</th>
                            <th width="110px" style="text-align:center;" v-if="(janShow && (filter.view=='full'))">Jan {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(febShow && (filter.view=='full'))">Feb {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(marShow && (filter.view=='full'))">Mar {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(aprShow && (filter.view=='full'))">Apr {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(meiShow && (filter.view=='full'))">Mei {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(junShow && (filter.view=='full'))">Jun {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(julShow && (filter.view=='full'))">Jul {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(agtShow && (filter.view=='full'))">Aug {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(sepShow && (filter.view=='full'))">Sep {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(oktShow && (filter.view=='full'))">Okt {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(novShow && (filter.view=='full'))">Nov {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(desShow && (filter.view=='full'))">Des {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(filter.view=='ytd')">{{filter.bulan}} {{filter.tahun}}</th>
                            <th width="110px" style="text-align:center;" v-if="(filter.view=='ytd')">%</th>
                            <th width="110px" style="text-align:center;">Year To Date</th>
                            <th width="110px" style="text-align:center;">%</th>
                            <th width="110px" style="text-align:center;">TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in cflw.lines" :key="row.idrowunik">
                            <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                            <td :class="row.kelas"  v-if="(janShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,1)">{{row.jan | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(febShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,2)">{{row.feb | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(marShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,3)">{{row.mar | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(aprShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,4)">{{row.apr | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(meiShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,5)">{{row.mei | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(junShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,6)">{{row.jun | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(julShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,7)">{{row.jul | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(agtShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,8)">{{row.agt | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(sepShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,9)">{{row.sep | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(oktShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,10)">{{row.okt | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(novShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,11)">{{row.nov | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(desShow && (filter.view=='full'))" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonthly(row,12)">{{row.des | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(filter.view=='ytd')" style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillCurrentMonth(row)">{{row.monthtt | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas"  v-if="(filter.view=='ytd')" style="text-align:right">
                                <span v-if="row.kode || row.rumus">{{row.persen_month | numFormat}}</span>
                            </td>
                            <td :class="row.kelas"  style="text-align:right">
                                <b-link v-if="row.kode || row.rumus" @click="drillMonToDate(row)">{{row.total | numFormat}}</b-link>
                            </td>
                            <td :class="row.kelas" style="text-align:right">
                                <span v-if="row.kode || row.rumus">{{row.persen_md | numFormat}}</span>
                            </td>
                            <td :class="row.kelas" style="text-align:right">
                                <span v-if="row.kode || row.rumus">{{row.total | numFormat}}</span>
                            </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
            <b-row class="mb-2">
                <b-col lg="5">
                    <b-input-group>
                        <b-input-group-prepend ><span class="ml-2 mr-1 pt-1">View : </span></b-input-group-prepend>
                        <b-form-radio-group class="mt-2" v-model="filter.view" name="radioView">
                            <b-form-radio value="ytd">Year to Date  </b-form-radio>
                            <b-form-radio value="full">Full Coloum (12 Months)</b-form-radio>
                        </b-form-radio-group>
                    </b-input-group>
                </b-col>
                <b-col lg="7">
                    <b-input-group v-if="(filter.view=='full')">
                        <b-input-group-prepend><label> &nbsp;&nbsp;&nbsp;Hide Column   :</label></b-input-group-prepend>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="janShow" class="mt-1 mr-2" size="sm">Jan</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="febShow" class="mt-1 mr-2" size="sm">Feb</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="marShow" class="mt-1 mr-2" size="sm">Mar</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="aprShow" class="mt-1 mr-2" size="sm">Apr</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="meiShow" class="mt-1 mr-2" size="sm">Mei</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="junShow" class="mt-1 mr-2" size="sm">Jun</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="julShow" class="mt-1 mr-2" size="sm">Jul</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="agtShow" class="mt-1 mr-2" size="sm">Agt</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="sepShow" class="mt-1 mr-2" size="sm">Sep</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="oktShow" class="mt-1 mr-2" size="sm">Oct</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="novShow" class="mt-1 mr-2" size="sm">Nov</b-form-checkbox>
                        <b-form-checkbox :value="false" :unchecked-value="true" v-model="desShow" class="mt-1 mr-2" size="sm">Dec</b-form-checkbox>
                    </b-input-group>
                </b-col>
            </b-row>

        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>

    </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import cashflow from "../../apis/cashflow";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1, view:'ytd',tahun:moment(this.$store.state.user.tglaktif).format('YYYY'), bulan:moment(this.$store.state.user.tglaktif).format('MMM'),},
      janShow:true,
      febShow:true,
      marShow:true,
      aprShow:true,
      meiShow:true,
      junShow:true,
      julShow:true,
      agtShow:true,
      sepShow:true,
      oktShow:true,
      novShow:true,
      desShow:true,

      isLoading: false,
      layouts:[],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      cflw:{lines:[]}
    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
        // this.cflw.lines= await cashflow.layoutcashflow({layout : newval});
        const lines = await cashflow.layoutcashflow({layout : newval});
        const hasil = lines.reduce((newArr, line) => {
            if (line.item_hapus !== 1) newArr.push(line);
            return newArr;
        }, []);          
          this.cflw.lines=hasil;

      }
  },
created: async function (){
     this.layouts = await cashflow.layoutcashflow_combo();
    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');
  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tahun= tgl2.format('YYYY') *1;
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAK BENAR,  jika api controller didaftar di sys_api
                this.cflw.lines= await cashflow.cashflowthn(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.showReport=true;
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.reportUrl= await cashflow.cashflowthnprint(model);
                this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAK BENAR,  jika api controller didaftar di sys_api
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');

                const response = await cashflow.cashflowthnexport(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    drillMonthly: function(data,monthOf)
    {
        if (data.kode) {
            var tgl1 = moment(`${this.filter.tgl2.substring(0,4)}-${monthOf}-01`,'YYYY-MM-DD');
            // router.push({name :'accounting.gl', params: { kodeaw: data.kode, kodeak: data.kode, 
            // tgl1:tgl1.format('YYYY-MM-DD'), tgl2: tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}});
            let routeData = router.resolve({path: `general-ledger/${data.kode}/${tgl1.format('YYYY-MM-DD')}/${tgl1.add(1,'M').subtract(1, 'day').format('YYYY-MM-DD')}`});
            window.open(routeData.href, '_blank');

        }
    },
    drillCurrentMonth: function(data)
    {
        if (data.kode) {
            var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
            // router.push({name :'accounting.gl', params: { kodeaw: data.kode, kodeak: data.kode, tgl1:`${tgl2.format('YYYY-MM')}-01`, tgl2: this.filter.tgl2}});
            let routeData = router.resolve({path: `general-ledger/${data.kode}/${tgl2.format('YYYY-MM')}-01/${this.filter.tgl2}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillMonToDate: function(data)
    {
        if (data.kode) {
            // router.push({name :'accounting.gl', params: { kodeaw: data.kode, kodeak: data.kode, tgl1:this.filter.tgl1, tgl2: this.filter.tgl2}});
            let routeData = router.resolve({path: `general-ledger/${data.kode}/${this.filter.tgl1}/${this.filter.tgl2}`});
            window.open(routeData.href, '_blank');
        }
    },
    cfinvalid: function()
    {
        let routeData = router.resolve({path: `trx-cf-acc-invalid/${this.filter.tgl1}/${this.filter.tgl2}`});
        window.open(routeData.href, '_blank');
    },
    close(){
      router.push("home");
    }
  }
};
</script>
